import t from"react";import e from"../theme/theme-context";export default()=>t.useContext(e);